##
# Put this directive on any ngModel element and it will be ignored when checking for form pristine state
#
# **Usage**
# as attribute:
# <ANY
#    [data-form-ignore]
# >
# ...
# </ANY>
##
angular
	.module 'App.Directive'
	.directive 'formIgnore', ->
		restrict: 'A'
		require: 'ngModel'
		link: (scope, element, attributes, ngModelCtrl) ->
			ngModelCtrl.$pristine = false
			ngModelCtrl.$setPristine = angular.noop
			ngModelCtrl.$setDirty = angular.noop
			ngModelCtrl.$setValidity = angular.noop
